import AWS from 'aws-sdk';

const s3Client = new AWS.S3({
    forcePathStyle: false,
    endpoint: "https://nyc3.digitaloceanspaces.com",
    region: "us-east-1",
    credentials: {
        accessKeyId: process.env.REACT_APP_DO_SPACES_KEY,
        secretAccessKey: process.env.REACT_APP_DO_SPACES_SECRET,
    },
});

export const uploadFileToDigitalOcean = async (file, filePath) => {
    try {
        const params = {
            Bucket: process.env.REACT_APP_DO_SPACES_ID,
            Key: filePath,
            Body: file,
            ACL: 'public-read',
            ContentType: 'application/pdf'
        };

        await s3Client.upload(params).promise();
        return true;
    } catch (error) {
        console.error('Error uploading file to Digital Ocean:', error);
        throw error;
    }
};

export const deleteFileFromDigitalOcean = async (filePath) => {
    try {
        const params = {
            Bucket: process.env.REACT_APP_DO_SPACES_ID,
            Key: filePath
        };

        await s3Client.deleteObject(params).promise();
        return true;
    } catch (error) {
        console.error('Error deleting file from Digital Ocean:', error);
        throw error;
    }
}; 